import Vue from 'vue'
import { provider } from '@/services'
import { Store } from 'vuex/types/index'

export const prepareServices = (store: Store<any>): void => {
  store.$services = provider()

  Vue.mixin({
    beforeCreate () {
      this.$services = store.$services
    }
  })
}